export default [
  {
    Attribute: 'Actual Dimension',
    Abbreviation: 'ACTUAL MTL DIM',
    Definition: 'For a Bill of Material Line Item, the length/width of a material delivered by a supplier to a factory for production, also used for the usage calculation for non-leather materials or components.  Example: 54" x 36"',
  },
  {
    Attribute: 'Cable Count',
    Abbreviation: '',
    Definition: 'The number of the loops during the manual winding process.',
  },
  {
    Attribute: 'Clip Count',
    Abbreviation: '',
    Definition: 'The number of clips required to hold the wire.',
  },
  {
    Attribute: 'Confirmed Due Date',
    Abbreviation: '',
    Definition: 'The target date for when Nike has confirmed the FOB Cost for a given season, and no further changes are expected to non-tooling costs. This state is only available during the FOB Confirmation milestone for quotes. ',
  },
  {
    Attribute: 'Consumption Conversion Rate (g/cm2)',
    Abbreviation: 'CONS CONV RATE (g/cm2)',
    Definition: 'On a BOM line item, a value used to represent the amount of a process material used during production, and a way to calculate material costs when the material unit price is in grams and the material usage is in cm2.',
  },
  {
    Attribute: 'Costing Season',
    Abbreviation: '',
    Definition: 'The season used to determine the time-based costing inputs to FOB Cost calculations. This may differ from the Line Plan Season due to variations in purchasing patterns (early or late buys). E.g. SU20, FA21'
  },
  {
    Attribute: 'Costing Size',
    Abbreviation: '',
    Definition: 'The average shoe size on the bell curve for what is typically ordered within a given category; age and gender. Costing everything at that size would, then, provide as near a correct average cost as is reasonably possible',
  },
  {
    Attribute: 'Count',
    Abbreviation: '',
    Definition: 'On a Bill of Labor line item, the number of times a standard or custom process is accounted for.',
  },
  {
    Attribute: 'Country Of Origin',
    Abbreviation: '',
    Definition: 'The country of the supplier location that provides the material or component.',
  },
  {
    Attribute: 'Development Target FOB Cost',
    Abbreviation: 'Target FOB Cost',
    Definition: 'The budget value used by product development for the FOB (Free on Board) cost that does not include tooling, in the currency specified in the currency code.',
  },
  {
    Attribute: 'Duty Driver',
    Abbreviation: '',
    Definition: 'Duty is the classification of the tax levied by governments on the value (including freight and insurance) of imports. Example: Leather, Textile, Synthetic. The target duty driver for a product is the intended duty classification as the product is developed; the Actual Duty Driver is determined via physical measurements of the upper of the product once a sample has been created.',
  },
  {
    Attribute: 'Exchange Rate Reference Date',
    Abbreviation: '',
    Definition: 'The date used to determine any exchange rate used in a cost calculation for a cost sheet.',
  },
  {
    Attribute: 'Factory Cost Standard Effective Date',
    Abbreviation: 'Effective on…',
    Definition: 'The date on which the Factory Cost Standard value becomes valid. No end date is provided; the value is effective until a subsequent value is entered with a later date.',
  },
  {
    Attribute: 'Factory Excess Multiplier',
    Abbreviation: 'FEM',
    Definition: 'The value used to modify the total standard minutes for a labor process on a BOL Line Item for the purpose of measuring factory excess time.',
  },
  {
    Attribute: 'Factory In-house Source Indicator',
    Abbreviation: 'FCTY IN-HOUSE',
    Definition: 'A two-value switch to indicate whether a factory has developed a Bill of Materials (BOM) or  Bill of Labor (BOL) line item within its own facility. Yes - the item has been sourced in-house; No - the item has been outsourced to another facility.',
  },
  {
    Attribute: 'Factory Overhead Cost',
    Abbreviation: 'Overhead Cost',
    Definition: 'A per pair or piece allocation of costs for a factory location that are not product or process specific and are necessary to directly or indirectly support the manufacture of a product. ',
  },
  {
    Attribute: 'Factory Unit Price',
    Abbreviation: 'FCTY UNIT PRICE',
    Definition: 'For a Bill of Material Line Item provided by a factory, the latest FOB cost for a supplied material or component, in a specified currency and unit of measure.',
  },
  {
  Attribute: 'Flyknit',
  Abbreviation: '',
  Definition: 'The portion of the Upper Material cost for Flyknit materials.',
  },
  {
    Attribute: 'FOB Cost',
    Abbreviation: '',
    Definition: 'The price invoiced or quoted by a Nike Vendor for the goods as agreed to by the buyer, Nike. Other charges (such as shipping and other product surcharges) may be added to the FOB in the invoice as part of the terms of sale. This value is finalized at FOB Confirmation and does not include tooling costs. ',
  },
  {
    Attribute: 'FOB Cost Effective Date',
    Abbreviation: 'FOB Effective Date',
    Definition: 'The date upon which an FOB Cost (without tooling) value becomes valid for a development style/colorway within a season. The initial date is set during the FOB Cost Confirmation milestone within a season when the Quote State is marked as "Confirmed". Note that tooling adjustments may result in additional effective dates for the FOB With Tooling Cost, but these adjustments do not change this FOB Cost Effective Date.',
  },
  {
    Attribute: 'Factory Labor Rate',
    Abbreviation: '',
    Definition: 'Average cost of labor directly supporting the manufacture of a product and associated to a particular Factory location. This is expressed as US Dollars per minute.',
  },
  {
    Attribute: 'FOB Cost With Tooling',
    Abbreviation: '',
    Definition: 'Contains the sum of the FOB Cost and the tooling cost, in the currency specified by the currency code.',
  },
  {
    Attribute: 'Freight Term',
    Abbreviation: 'FRT TRM',
    Definition: 'Denotes the Shipping Terms used for the supplied material to be used by PCC for landed cost calculations. Freight Code Examples: FOB, EXFTY, OTHER.',
  },
  {
    Attribute: 'Glidepath Cost',
    Abbreviation: '',
    Definition: 'On a CBD (Cost Breakdown) report, a per-pair cost value for temporary compensation to support a factory’s transition to Nike Costing. Nike leadership and the Nike Costing Framework team (NCF) will approve amount and timing.',
  },
  {
    Attribute: 'Gross Usage',
    Abbreviation: '',
    Definition: 'For a Bill of Material Line Item, the total area, weight or quantity of a supplied material consumed, including the net usage and waste usage.',
  },
  {
    Attribute: 'In-house Labor Cost',
    Abbreviation: '',
    Definition: 'The total cost for all labor processes conducted within the sourced factory.'
  },
  {
    Attribute: 'Is Early or Late Buy Indicator',
    Abbreviation: '',
    Definition: 'A 2-state flag that indicates whether a quote exists for a product purchased either earlier or later than its line plan season. Yes – the quote is for a product purchase that is earlier or later than a quote in its line plan season. No – the quote represents a standard-timing quote based on the line plan season or some other standardized offset from that season. E.g. An early buy quote (set to Yes) for a product in the SU20 line plan uses the SP20 season for its costing inputs.'
  },
  {
    Attribute: 'Is Custom',
    Abbreviation: '',
    Definition: 'A 2-state switch to indicate whether a labor process is custom vs. standardized. Yes - the process is custom and has not been standardized and an observed minutes value is provided on BOL; No - the process has been standardized and a standard minute value or formula exists in a cost standards library',
  },
  {
    Attribute: 'Is Placeholder',
    Abbreviation: '',
    Definition: 'A 2-state switch to indicate whether a custom labor process functions as a temporary placeholder for some other process while on the Bill of Labor. Yes - the process functions as a placeholder; No - the process is a valid process as defined in the library.',
  },
  {
    Attribute: 'Labor Cost',
    Abbreviation: '',
    Definition: 'On a Bill of Labor line item, represents the full cost of the Labor Process involved. For in-house processes, the value is calculated using the labor rate and process time (in minutes). For outsourced processes, a value is input to represent the full per-pair cost.',
  },
  {
    Attribute: 'Labor Cost Reference Date',
    Abbreviation: '',
    Definition: 'The reference date used to determine all labor cost standard values used in the labor calculation.',
  },
  {
    Attribute: 'Labor FOB Cost Percent',
    Abbreviation: '% of FOB Cost',
    Definition: 'The percent that a labor cost contributes to the FOB Cost for a product. Calculated by dividing the Labor Cost by the FOB Cost (without tooling).',
  },
  {
    Attribute: 'Labor Minutes',
    Abbreviation: '',
    Definition: 'On a Bill of Labor Line Item, the time taken to complete a Labor Process. For standard processes, this includes a factory efficiency multiplier (FEM) adjustment. For an observed custom process, no adjustment is made.',
  },
  {
    Attribute: 'Labor Process Identifier',
    Abbreviation: 'LABOR PROCESS ID',
    Definition: 'An identifier is an integer that uniquely identifies a record within an entity. ',
  },
  {
    Attribute: 'Labor Process Name',
    Abbreviation: '',
    Definition: 'A step or activity in the manufacture of a product. Examples: Laser Siping, Spray Painting',
  },
  {
    Attribute: 'Labor Process Status',
    Abbreviation: '',
    Definition: 'A 2-state switch that specifies if a labor process is considered active and for valid use on a BOL. Active - the labor process is valid for use; Inactive - the labor process is not valid for use.',
  },
  {
    Attribute: 'Landed Cost',
    Abbreviation: 'US LND $',
    Definition: 'The full cost of a supplied material or component after calculations involving material transportation, waste and defects. Originates on the Bill of Material Line Item, but can be aggregated to a summary level.',
  },
  {
    Attribute: 'Landed Cost Percent',
    Abbreviation: 'LND %',
    Definition: 'For a Bill of Material Line Item, the percent to be applied to a unit price for a supplied material or component to represent the cost associated with transporting that material to a production location.',
  },
  {
    Attribute: 'Landed Defect Cost',
    Abbreviation: 'DEFECT LND $',
    Definition: 'The cost of a supplied material or component that could be defective during the manufacturing process. Originates on the Bill of Material Line Item, but can be aggregated to a summary level.',
  },
  {
    Attribute: 'Landed Gross Cost',
    Abbreviation: 'GROSS LND $',
    Definition: 'The landed cost for gross usage of a supplied material or component, including both net and waste costs. Originates on the Bill of Material Line Item, but can be aggregated to a summary level.',
  },
  {
    Attribute: 'Landed Net Cost',
    Abbreviation: 'NET LND $',
    Definition: 'The landed cost for the net usage of a supplied material or component. Originates on the Bill of Material Line Item, but can be aggregated to a summary level.',
  },
  {
    Attribute: 'Landed Unit Cost',
    Abbreviation: 'LND $',
    Definition: 'The unit cost of transporting a supplied material or component to a production location, calculated using the Material Landed Cost Percent.',
  },
  {
    Attribute: 'Landed Waste Cost',
    Abbreviation: 'WASTE LND $',
    Definition: 'The landed cost for the waste usage of a supplied material or component. Originates on the Bill of Material Line Item, but can be aggregated to a summary level.',
  },
  {
    Attribute: 'Length',
    Abbreviation: '',
    Definition: 'The total length measured for the labor process per component in centimetres.',
  },
  {
    Attribute: 'Line Item Defect Percent',
    Abbreviation: 'DEFECT %',
    Definition: 'For a Bill of Material Line Item, the negotiated or agreed-to percentage of a supplied material or component that provides an allowance for defects that could occur during the manufacturing process.',
  },
  {
    Attribute: 'Material Cost Reference Date',
    Abbreviation: '',
    Definition: 'The reference date used to determine all material prices used in the material cost calculation.',
  },
  {
    Attribute: 'Material FOB Cost Percent',
    Abbreviation: '% of FOB Cost',
    Definition: "The percent that a material cost contributes to the FOB Cost for a product. Calculated by dividing the material's Landed Cost by the FOB Cost (without tooling).",
  },
  {
    Attribute: 'Material Price Effective Date',
    Abbreviation: 'MTL PRICE EFFECTIVE DATE',
    Definition: '  The date on which a Supplied Material Price becomes valid.',
  },
  {
    Attribute: 'Material Profit Exclusion Indicator',
    Abbreviation: 'PROFIT EXCLUDED',
    Definition: 'For a Bill of Material Line Item, a 2-state switch to specify whether the line item cost should be excluded from the calculation of profit cost. Yes - means that the material cost is excluded from the profit calculation; No - the material cost is included in the profit calculation.',
  },
  {
    Attribute: 'Net Usage',
    Abbreviation: '',
    Definition: 'For a Bill of Material Line Item, the area, weight or quantity of a supplied material that is included in a finished product.',
  },
  {
    Attribute: 'NonFlyknit',
    Abbreviation: '',
    Definition: 'The portion of the Upper Material cost for all materials except Flyknit.',
   },
  {
    Attribute: 'Observed Minutes',
    Abbreviation: '',
    Definition: 'On a Bill of Labor line item, the value entered for custom processes that represents the duration (inclusive of standard excess minutes) of a single custom process.',
  },
  {
    Attribute: 'Overhead Cost',
    Abbreviation: '',
    Definition: 'A factory overhead cost classified by overhead cost type such as Depreciation and Utilities.',
  },
  {
    Attribute: 'Other Cost Adjustment',
    Abbreviation: '',
    Definition: 'A cost adjustment not associated to any known cost component (materials, labor, overhead, profit, tooling).',
  },
  {
    Attribute: 'Other Cost Description',
    Abbreviation: '',
    Definition: 'An explanation for the cost value added as "Other Cost Adjustment"',
  },
  {
    Attribute: 'Other FOB Cost Percent',
    Abbreviation: '',
    Definition: 'The percent that an Other Adjustment Cost contributes to the FOB Cost for a product. Calculated by dividing Other Cost Adjustment into the FOB Cost (without tooling).',
  },
  {
    Attribute: 'Outsourced Labor Cost',
    Abbreviation: '',
    Definition: 'On a Bill of Labor line item, the full per-pair cost for an outsourced Labor Process, which may also include overhead and profit costs of the outsourced supplier.',
  },
   {
    Attribute: 'Outsourced Labor Cost Currency',
    Abbreviation: '',
    Definition: 'On a Bill of Labor line item, the currency in which the outsourced labor cost is provided.',
  },
  {
    Attribute: 'Overhead Cost Reference Date',
    Abbreviation: '',
    Definition: 'The reference date used to determine all overhead costs used in the overhead cost calculation.',
  },
  {
    Attribute: 'Overhead FOB Cost Percent',
    Abbreviation: '% of FOB Cost',
    Definition: 'The percent that an overhead cost contributes to the FOB Cost for a product. Calculated by dividing the Overhead Cost by the FOB Cost (without tooling).',
  },
  {
    Attribute: 'Part Name',
    Abbreviation: '',
    Definition: 'A component of a product made by combining and assembling materials during production. Examples: Vamp, Tongue, Quarter, Shank, Outsole',
  },
  {
    Attribute: 'Part Yield',
    Abbreviation: '',
    Definition: 'The gross usage of the actual dimension of materials for the part identified for the supplied material in the line item, as determined by Procost calculation methods, in a unit of measure that matches other usage values.',
  },
  {
    Attribute: 'Patch Count',
    Abbreviation: '',
    Definition: 'The Count specified by WHQ user or by Production Factory for the number of occurrence of a Patches in the Labor Process.',
  },
  {
    Attribute: 'PCX Cost Sheet Status',
    Abbreviation: 'Cost Sheet Status',
    Definition: 'A 2-value switch to indicate the status of a PCX Cost Sheet. Active – the cost sheet is currently being used to manage costing data. Inactive – the cost sheet is not being used to manage costing data.',
  },
  {
    Attribute: 'Pin Count',
    Abbreviation: '',
    Definition: 'Total Pins attachment required in 1 pallet',
  },
  {
    Attribute: 'Press Count',
    Abbreviation: '',
    Definition: 'Total pressing required for rubber press',
  },
  {
    Attribute: 'Profit Cost',
    Abbreviation: '',
    Definition: 'The factory profit cost calculated from labor, overhead and materials (with certain materials excluded), modified by a profit rate percent.',
  },
  {
    Attribute: 'Profit Cost Reference Date',
    Abbreviation: '',
    Definition: 'The reference date used to determine profit cost used in the profit cost calculation.',
  },
  {
    Attribute: 'Profit FOB Cost Percent',
    Abbreviation: '% of FOB Cost',
    Definition: 'The percent that a profit cost contributes to the FOB Cost for a product. Calculated by dividing the Profit Cost by the FOB Cost (without tooling).',
  },
  {
    Attribute: 'Profit Rate Percent',
    Abbreviation: '',
    Definition: "The rate used to calculate a Factory location's profit amount per product. The summed costs of materials, labor and overhead Free on Board (FOB) elements (with profit-exception items excluded) are multiplied by this value to determine the Factory profit amount per product.",
  },
  {
    Attribute: 'Quote State Actual Date',
    Abbreviation: '',
    Definition: 'The date on which the Quote State changes. This is to be compared with the Due Date (when the state was supposed to change based on a target date) to determine any gaps.',
  },
  {
    Attribute: 'Ready for Review Due Date',
    Abbreviation: '',
    Definition: 'The target date for when the PCC has submitted and reviewed all that has been requested for a quote and the Cost Breakdown (CBD) report contains accurate values.',
  },
  {
    Attribute: 'Reviewed Due Date',
    Abbreviation: '',
    Definition: 'The target date for when Nike has reviewed all costing values and the FOB cost is set for the present milestone/gate. This is the final state for any non-canceled request before FOB Confirmation. ',
  },
  {
    Attribute: 'Rubber Component Count',
    Abbreviation: '',
    Definition: 'Total rubber preform that need to add on the rubber pressing machine',
  },
  {
    Attribute: 'Season',
    Abbreviation: '',
    Definition: 'The Line Plan Season in which the Dev Style Colorway appears. This may differ from the Costing Season due to variations in purchasing patterns (early or late buys). E.g. SU20, FA21'
  },
  {
    Attribute: 'Shoe Count',
    Abbreviation: '',
    Definition: 'The number of shose that can be added in 1 pallet.',
  },
  {
    Attribute: 'Slit Count',
    Abbreviation: '',
    Definition: 'Number of slits or holes the Dynamic Flywire brio cables are inserted thru (on one shoe) including around or near the eyelets.',
  },
  {
    Attribute: 'Standard Minutes',
    Abbreviation: '',
    Definition: 'The time required (as a duration, in minutes) for a qualified worker working at "standard" performance to perform the process task, based on a statistical average from Predetermined Motion Time Systems (PMTS) studies. At a given point in time, a standardized Labor Process will have either a Standard Minute Formula or a Standard Minute Value, but not both.',
  },
  {
    Attribute: 'Target Material Cost',
    Abbreviation: '',
    Definition: "The budget amount for the cost for materials for a Dev Style and Season.",
   },
  {
    Attribute: 'Target Labor Cost',
    Abbreviation: '',
    Definition: "The calculated budget amount for the cost for labor processes for a Dev Style, Season and Factory Source.",
   },
   {
    Attribute: 'Target Profit Cost',
    Abbreviation: '',
    Definition: "The calculated budget amount for the cost of factory profit for a Dev Style, Season and Factory source.",
   },
   {
    Attribute: 'Target Overhead Cost',
    Abbreviation: '',
    Definition: "The calculated budget amount for the cost of overhead for a Dev Style, Season and Factory source.",
   },
   {
    Attribute: 'Target FOB Cost ',
    Abbreviation: '',
    Definition: "The budget value used by product development for the FOB (Free on Board) cost that does not include tooling, in the currency specified in the currency code.",
   },
   {
    Attribute: 'Target FOB Cost with Tooling',
    Abbreviation: '',
    Definition: "The budget value used by product development for the FOB (Free on Board) cost that includes tooling, in the currency specified in the currency code.",
   },
   {
    Attribute: 'Target Observed Minutes',
    Abbreviation: '',
    Definition: "The budget amount for the observed minutes taken for labor processes for a Dev Style and Season.",
   },
  {
  Attribute: 'Target Standard Minutes',
  Abbreviation: '',
  Definition: "The budget amount for the standard minutes taken for labor processes for a Dev Style and Season.",
  },
  {
    Attribute: 'Target Tooling Cost',
    Abbreviation: '',
    Definition: 'The budget value for tooling costs associated with a development style within a season, in the currency specified in the currency code.',
  },
  {
    Attribute: 'Tooling FOB Cost Percent',
    Abbreviation: '',
    Definition: 'The percent that tooling contributes to the FOB Cost for a product. Calculated by dividing the Tooling Cost by the full FOB Cost (without tooling).',
  },
  {
    Attribute: 'Total Landed Unit Cost',
    Abbreviation: 'TOTAL LND UNIT $',
    Definition: 'The full landed unit cost for a supplied material or component, including the cost of transportation to a production location.',
  },
  {
    Attribute: 'Total Observed Minutes',
    Abbreviation: '',
    Definition: 'On a Bill of Labor Line Item, the time taken to complete a custom Labor Process, calculated as the Observed Minutes multiplied by the number of times it occurs (Bill of Labor Count).',
  },
  {
    Attribute: 'Total Standard Minutes',
    Abbreviation: '',
    Definition: 'On a Bill of Labor Line Item, the time taken to complete a standard Labor Process, calculated using a Standard Minute Value or Standard Minute Formula, multiplied by the number of times it occurs (Bill of Labor Count).',
  },
  {
    Attribute: 'Total Unit Price',
    Abbreviation: '',
    Definition: 'The total FOB base cost for a supplied material, including the unit price plus any upcharge, in a specified currency and unit of measure on a given effective date.',
  },
  {
    Attribute: 'Trim Count',
    Abbreviation: '',
    Definition: 'The number of cuts related Dynamic flywire process per 1 shoe.',
  },
  {
    Attribute: 'Unit Price',
    Abbreviation: '',
    Definition: 'The unit cost for a supplied material or component, in a specified currency and unit of measure.  This is the price stored in the Supplied Material Price effectivity library.',
  },
  {
    Attribute: 'Unit Price Upcharge',
    Abbreviation: 'UNIT PRICE UPCHG',
    Definition: 'For a Bill of Material Line Item provided by a factory, the latest additional factory unit cost (beyond the unit price) for a supplied material or component, in a specified currency and unit of measure.',
  },
  {
    Attribute: 'Unit Price Upcharge Description',
    Abbreviation: 'UPCHG DESC',
    Definition: 'For a Bill of Material Line Item provided by a factory, the reason for the additional FOB unit cost (beyond the unit price) for a supplied material or component.',
  },
  {
    Attribute: 'Usage Efficiency Percent',
    Abbreviation: 'EFF %',
    Definition: 'The usage efficiency of a material on a product, as a percent, calculated by dividing net usage by gross usage. May be calculated on a material line item, by part, or for the entire product.',
  },
  {
    Attribute: 'Waste Usage',
    Abbreviation: '',
    Definition: 'For a Bill of Material Line Item, the area, weight, or quantity of a supplied material that is discarded during the manufacturing process or a calculated amount of a supplied material that could be discarded based on agreed standard parameters.',
  }
];




// WEBPACK FOOTER //
// ./src/components/AttributeGlossary/glossaryData.js